export default __webpack_public_path__ + "static/media/rejected-icon.174a03c8.svg";